<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/custom/plan/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_data_select :multiple="true" :max="99" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL> </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR> </template>
      <!-- 自定义某个字段 -->
      <!-- 角色 -->
      <template #zidingyijihuachanliang="scope">
        <template>
          <div :style="{ background: scope.row.quantity == 9999999 ? 'orange' : null }" style="width: 100%;height: 100%;display: flex;flex-direction: column;background: red;justify-content: center;padding: 20px;">
            <el-input-number v-model="scope.row.quantity" :min="0" :max="9999999" />
          </div>
        </template>
      </template>

      <!-- 底部插槽 -->
      <template #footer> </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_production_custom_production',
  components: {},

  data() {
    return {
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'zidingyijihuachanliang',
          type: 'slot'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      //   this.yt.isShowPagination = false;
      //   this.yt.pageSize = 1000;

      this.yt.get(1);
    }, 300);
  },

  methods: {
    batchCreateOrUpdate() {
      let params = [];
      for (let index = 0; index < this.yt.list.length; index++) {
        const item = this.yt.list[index];
        if (item.quantity != null) {
          params.push({
            id: item.id,
            equipmentId: item.equipment.id,
            quantity: item.quantity
          });
        }
      }

      this.http
        .post('/web/custom/plan/batchCreateOrUpdate', params)
        .then(res => {
          this.utils.event_hub.$emit('UpdatePlanProduction');
          this.utils.successMessage(this.$t(res.msg));
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    }
  }
};
</script>
